import React, { useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Form,
  Spinner,
} from "reactstrap";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import classnames from "classnames";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import {
  useArticle,
  useArticleCategories,
  useValidateArticle,
} from "../../../hooks/useArticles";

import SwiperCore, { FreeMode, Navigation, Thumbs } from "swiper";
import { useParams } from "react-router-dom";
import { useFormik } from "formik";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

SwiperCore.use([FreeMode, Navigation, Thumbs]);

function ArticlesDetail(props) {
  const { id } = useParams();
  const history = useHistory();
  const { data: categories = [] } = useArticleCategories();
  const {
    data: article,
    isLoading,
    error,
  } = useArticle(id);

  const categoryLabel =
    article?.category_name ||
    categories.find((item) => item.id === article?.category)?.designation ||
    "-";

  const [customActiveTab, setcustomActiveTab] = useState("1");
  const toggleCustom = (tab) => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab);
    }
  };
  const validateMutation = useValidateArticle();
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {},
    onSubmit: () => {
      validateMutation.mutate(id, {
        onSuccess: () => {
          validation.resetForm();
          history.push("/articles");
        },
      });
    },
  });
  document.title = props.t("Détail d'un article'");
  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title={props.t("Détail d'un article")}
          pageTitle={props.t("Article")}
        />
        <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                {isLoading ? (
                  <div className="py-4 text-center">
                    <div className="mt-4">
                      <h5>{props.t("Chargement")}...</h5>
                    </div>
                  </div>
                ) : error ? (
                  <div className="py-4 text-center">
                    <div className="mt-4">
                      <h5>{error.message || props.t("Une erreur est survenue")}</h5>
                    </div>
                  </div>
                ) : (
                  <>
                    <Row className="gx-lg-5">
                      <Col xl={12}>
                        <div className="mt-xl-0 mt-5">
                          <Row>
                            <Col lg={6}>
                              <img
                                src={article?.article_pic}
                                className="rounded"
                                style={{ width: "100%" }}
                                alt={article?.title || "Article"}
                              />
                            </Col>
                            <Col lg={6}>
                              <div className="product-content ">
                                <Nav tabs className="nav-tabs-custom nav-warning">
                                  <NavItem>
                                    <NavLink
                                      style={{ cursor: "pointer" }}
                                      className={classnames({
                                        active: customActiveTab === "1",
                                      })}
                                      onClick={() => {
                                        toggleCustom("1");
                                      }}
                                    >
                                      {props.t("Détails")}
                                    </NavLink>
                                  </NavItem>
                                </Nav>

                                <TabContent
                                  activeTab={customActiveTab}
                                  className="border border-top-0 p-4"
                                  id="nav-tabContent"
                                >
                                  <TabPane id="nav-speci" tabId="1">
                                    <div className="table-responsive">
                                      <table className="table mb-0">
                                        <tbody>
                                          <tr>
                                            <th scope="row">{props.t("Statut")}</th>
                                            <td style={{ color: "blue" }}>
                                              {!article?.validated ? (
                                                <div
                                                  className="fs-12 uppercase badge badge-soft-danger"
                                                  style={{
                                                    textAlign: "center",
                                                    fontSize: "13px",
                                                  }}
                                                >
                                                  En attente
                                                </div>
                                              ) : (
                                                <div
                                                  className="fs-12 uppercase badge badge-soft-success"
                                                  style={{
                                                    textAlign: "center",
                                                    fontSize: "13px",
                                                  }}
                                                >
                                                  Validé
                                                </div>
                                              )}
                                            </td>
                                          </tr>
                                          <tr>
                                            <th scope="row">{props.t("Validé par")}</th>
                                            <td style={{ fontStyle: "italic" }}>
                                              {article?.validated_by?.username ||
                                                "Non renseigné"}
                                            </td>
                                          </tr>
                                          <tr>
                                            <th scope="row">{props.t("Auteur")}</th>
                                            <td style={{ fontStyle: "italic" }}>
                                              {article?.author?.username || "-"}
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </TabPane>
                                </TabContent>
                              </div>
                            </Col>
                          </Row>
                          <div className="d-flex">
                            <div className="flex-wrap gap-3">
                              <br />
                              <h2>{article?.title}</h2>
                              <span className="text-xl fw-medium badge-soft-warning me-1">
                                {categoryLabel}
                              </span>
                            </div>
                          </div>
                          <div
                            className="mt-4 text-muted d-flex flex-column gap-4"
                            style={{ textAlign: "justify" }}
                          >
                            {(article?.paragraphs || []).map((item) => (
                              <div key={item.id} className="border rounded p-3">
                                {item.paragraph_pic ? (
                                  <img
                                    src={item.paragraph_pic}
                                    alt={item.subtitle || article?.title}
                                    className="rounded mb-3"
                                    style={{ width: "100%", maxHeight: 320, objectFit: "cover" }}
                                  />
                                ) : null}
                                {item.subtitle ? (
                                  <h5 className="mb-3">{item.subtitle}</h5>
                                ) : null}
                                <p className="mb-0">{item.content}</p>
                              </div>
                            ))}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </>
                )}
                {!article?.validated && !isLoading && !error ? (
                  <Form
                    encType="multipart/form-data"
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                    }}
                  >
                    <div className="text-end mb-3">
                      <Link to="/articles" className="btn btn-primary me-2">
                  {props.t("Retour")}
                </Link>
                      <button
                        type="submit"
                        className="btn btn-warning m-2"
                        disabled={validateMutation.isPending}
                      >
                        {validateMutation.isPending && (
                          <Spinner size="sm" className="me-2" />
                        )}
                        {props.t("Valider l'article")}
                      </button>
                    </div>
                  </Form>
                ) : (
                  <div className="text-end mb-3">
                    <Link to="/articles" className="btn btn-warning me-2">
                  {props.t("Retour")}
                </Link>
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

ArticlesDetail.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter(withTranslation()(ArticlesDetail));
